import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Formik } from 'formik';
import LoadMask from 'components/LoadMask';
import BasicButtonGroup from 'components/BasicButtonGroup';
import BasicButton from 'components/BasicButton';
import BasicSubmitButton from 'components/BasicSubmitButton';
import FiltersAccordion from 'scenes/FiltersAccordion';
import FiltersPartial from 'scenes/FiltersAccordion/components/FiltersPartial';
import HorizontalLoader from 'components/HorizontalLoader';
import { useFiltersAccordion } from 'hooks/useFiltersAccordion';
import { useApi } from 'hooks/useApi';
import { ANIMATION_TIMEOUT_APPEAR } from 'constants/animation.js';
import { ENDPOINT } from 'constants/endpoints';
import './styles.css';

const EditCandidateActivityRequirementsForm = props => {
  const {
    actions: { handleError, proceed, dismiss },
  } = props;

  const api = useApi();

  const [formData, setFormData] = useState({
    init: false,
    filters: {},
  });

  const [
    { sections, query },
    {
      init: initFilters,
      clear,
      change,
      groupClear,
      groupSelect,
      push,
      search: filterSearch,
    },
  ] = useFiltersAccordion();

  useEffect(() => {
    api.get(
      ENDPOINT.FORM.GET.ACCOUNT_CANDIDATE_ACTIVITY_ALERT_CRITERIA,
      {},
      {
        handleError: response => handleError(response),
        handleSuccess: response => {
          setFormData({ init: true });
          initFilters(response);
        },
      }
    );
  }, []);

  const handleSubmit = (
    values,
    { setSubmitting, setErrors, setFieldError }
  ) => {
    if (!Object.keys(query).length) {
      setFieldError('Value', 'Please add at least 1 filter');
      setSubmitting(false);
      return;
    }

    api.post(
      ENDPOINT.FORM.SAVE.ACCOUNT_CANDIDATE_ACTIVITY_ALERT_CRITERIA,
      { ...query },
      {
        handleError: response => {
          setSubmitting(false);
          handleError(response, setErrors);
        },
        handleSuccess: response => proceed(response),
      }
    );
  };

  return formData.init ? (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div className="form__inner alert-criteria-form">
        <Formik initialValues={formData.fields} onSubmit={handleSubmit}>
          {({ errors, handleSubmit, isSubmitting }) => (
            <form onSubmit={handleSubmit} className="form__content">
              {isSubmitting && <LoadMask />}

              <div
                className="form__header"
                style={{
                  display: 'flex',
                  padding: '0',
                  alignItems: 'center',
                }}
              >
                <h4 className="setup-email__form-title">Alert Criteria</h4>
              </div>

              <FiltersAccordion
                filters={sections}
                isFetching={false}
                onChange={change}
                onGroupSelectAll={groupSelect}
                onGroupClearAll={groupClear}
                onClearAll={clear}
                onSearch={filterSearch}
                onPushValue={push}
                compact={true}
                render={renderProps => (
                  <div style={{ position: 'relative' }}>
                    <FiltersPartial compact={true} {...renderProps} />
                    {errors.Value && (
                      <div
                        className="form__error form__error--custom"
                        style={{ position: 'absolute', bottom: '30px' }}
                      >
                        Please add at least 1 filter.
                      </div>
                    )}
                  </div>
                )}
              />

              <div
                className="form__controls form__controls--compact"
                style={{ maxWidth: '100%' }}
              >
                <BasicButtonGroup>
                  <BasicButton
                    controlFunc={dismiss}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnFontSize="0.8571rem"
                    btnArrow={false}
                    btnTextColor="#27282d"
                    btnText="Cancel"
                  />
                  <BasicSubmitButton
                    controlFunc={handleSubmit}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnFontSize="0.8571rem"
                    btnArrow={true}
                    btnTextColor="#27282d"
                    btnText="Save"
                  />
                </BasicButtonGroup>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </CSSTransition>
  ) : (
    <div className="form__inner">
      <div className="horizontal-loader__container">
        <HorizontalLoader />
      </div>
    </div>
  );
};

export default EditCandidateActivityRequirementsForm;
